import { render, staticRenderFns } from "./TermsService.vue?vue&type=template&id=656a5956&scoped=true&lang=pug&"
import script from "./TermsService.vue?vue&type=script&lang=js&"
export * from "./TermsService.vue?vue&type=script&lang=js&"
import style0 from "./TermsService.vue?vue&type=style&index=0&id=656a5956&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a5956",
  null
  
)

export default component.exports